import React from 'react';
import { useNavigate } from 'react-router-dom';
import FloatingCard from './FloatingCard';

const HeroSection: React.FC = () => {
  const navigate = useNavigate();

  return (
    <section className="relative overflow-hidden bg-appbg">
      <div className="pointer-events-none absolute left-[-300px] top-[-160px] h-[760px] w-[1120px] rounded-full bg-primary-50/70" />
      <div className="mx-auto max-w-[1728px] px-6 pb-10 pt-8 lg:px-20 lg:pt-12">
        <div className="grid items-center gap-14 lg:grid-cols-[620px_minmax(640px,1fr)] lg:gap-20">
          <div className="relative z-10 max-w-[620px]">
            <div className="inline-flex items-center gap-2 rounded-full bg-primary-100 px-4 py-1.5 text-[14px] font-semibold tracking-[-0.01em] text-primary-700">
              <span className="text-primary-600">✦</span>
              NEW: AI-POWERED AUDIT TRAIL
            </div>

            <h1 className="mt-6 max-w-[610px] text-[52px] font-extrabold leading-[0.98] tracking-[-0.03em] text-primary-800 sm:text-[64px] lg:text-[78px]">
              Real-time expense control,
              <br />
              <span className="italic">Zero surprises.</span>
            </h1>

            <p className="mt-7 max-w-[590px] text-[18px] leading-[1.35] tracking-[-0.01em] text-muted">
              Empower your team with intelligent spend management<br/> that scales with your ambition.
            </p>

            <div className="mt-10 flex flex-wrap items-center gap-4">
              <button
                type="button"
                onClick={() => navigate('/contact?intent=demo')}
                className="inline-flex h-[50px] min-w-[240px] items-center justify-center rounded-[14px] bg-primary-800 px-8 text-[20px] font-semibold text-white transition-colors duration-200 hover:bg-primary-700"
              >
                Request Demo →
              </button>
              {/* <button
                type="button"
                className="inline-flex h-[50px] min-w-[220px] items-center justify-center rounded-[14px] bg-primary-100 px-8 text-[20px] font-semibold text-primary-700 transition-colors duration-200 hover:bg-primary-200"
              >
                View Pricing
              </button> */}
            </div>

            {/* <div className="mt-10 flex items-center gap-4">
              <div className="flex -space-x-2">
                <img
                  src="https://images.unsplash.com/photo-1544005313-94ddf0286df2?auto=format&fit=crop&w=120&q=80"
                  alt="Finance team member"
                  className="h-10 w-10 rounded-full border-2 border-card object-cover"
                  loading="lazy"
                />
                <img
                  src="https://images.unsplash.com/photo-1500648767791-00dcc994a43e?auto=format&fit=crop&w=120&q=80"
                  alt="Finance team member"
                  className="h-10 w-10 rounded-full border-2 border-card object-cover"
                  loading="lazy"
                />
                <img
                  src="https://images.unsplash.com/photo-1494790108377-be9c29b29330?auto=format&fit=crop&w=120&q=80"
                  alt="Finance team member"
                  className="h-10 w-10 rounded-full border-2 border-card object-cover"
                  loading="lazy"
                />
              </div>
              <p className="text-[18px] font-medium tracking-[-0.01em] text-muted">
                Joined by <span className="font-semibold text-primary-600">2,500+</span> finance teams this month
              </p>
            </div> */}
          </div>

          <div className="relative z-10 flex justify-end pt-2">
            <div className="relative h-[668px] w-full max-w-[760px]">
              <div className="absolute right-0 top-0 h-[540px] w-full overflow-hidden rounded-[36px] bg-primary-50">
                <img
                  src="https://images.unsplash.com/photo-1521737604893-d14cc237f11d?auto=format&fit=crop&w=1500&q=80"
                  alt="Two coworkers walking through a bright office lobby"
                  className="h-full w-full object-cover object-center brightness-[0.95] saturate-[0.85]"
                  loading="eager"
                />
              </div>

              <FloatingCard className="absolute right-[-18px] top-[-48px] z-30 w-[250px] rounded-[22px] px-4 py-5 shadow-floating">
                <div className="flex items-center justify-between">
                  <p className="text-[16px] font-semibold tracking-[0.08em] text-muted">Active Budget</p>
                  <span className="text-[20px] text-primary-600 font-bold">↗</span>
                </div>
                <p className="mt-3 text-[18px] font-bold leading-none tracking-[-0.02em] text-primary-800">₹42,850.00</p>
                <div className="mt-2 h-2 overflow-hidden rounded-full bg-primary-50">
                  <div className="h-full w-[70%] bg-primary-500" />
                </div>
              </FloatingCard>

              <FloatingCard className="absolute left-[-58px] top-[80px] z-20 w-[356px] rounded-[20px] px-6 pb-5 pt-5 shadow-floating">
                <div className="inline-flex items-center rounded-[6px] bg-primary-700 px-[8px] py-[3px] text-[12px] font-medium text-white">
                  <span className="mr-1.5 text-[10px]">▣</span>
                  Business
                </div>
                <h3 className="mt-4 text-[24px] font-semibold leading-[1] tracking-[-0.01em] text-ink">
                  BOM → DEL
                </h3>
                <div className="mt-4 flex items-center gap-2.5 text-[14px] font-semibold tracking-[-0.01em] text-ink">
                  <span className="flex h-8 w-8 items-center justify-center rounded-full bg-primary-700 text-[14px] text-white">
                    ✈️
                  </span>
                  AIRLINE
                </div>
                <div className="mt-5 border-t border-line pt-5">
                  <div className="flex items-start justify-between">
                    <div>
                      <p className="text-[12px] text-muted">Business</p>
                      <p className="mt-1 text-[24px] leading-none text-muted">₹14,390</p>
                    </div>
                    <p className="pt-3 text-[12px] font-medium text-muted">Out-of-Policy</p>
                  </div>
                </div>
                <div className="mt-4 border-t border-line pt-4">
                  <div className="flex items-start justify-between">
                    <div>
                      <p className="text-[14px] font-semibold text-ink">Economy</p>
                      <p className="mt-1 text-[24px] font-semibold leading-none text-ink">₹8730</p>
                    </div>
                    <p className="pt-3 text-[12px] font-semibold text-primary-600">In-Policy</p>
                  </div>
                </div>
              </FloatingCard>

              <FloatingCard className="absolute bottom-[80px] left-[52px] z-20 flex w-[404px] items-center gap-4 rounded-[16px] px-4 py-4 shadow-floating">
                <span className="flex h-[42px] w-[42px] items-center justify-center rounded-[10px] bg-primary-700 text-[16px] font-semibold leading-none text-white">
                  flint
                </span>
                <div className="tracking-[-0.02em]">
                  <p className="text-[14px] font-semibold leading-none text-ink">Success!</p>
                  <p className="mt-1 text-[12px] leading-[1.2] text-muted">
                    Expense submitted. You&apos;re done.
                  </p>
                </div>
              </FloatingCard>

              <FloatingCard className="absolute bottom-[44px] right-[-30px] z-30 flex w-[252px] items-center gap-4 rounded-[16px] px-4 py-4 shadow-floating">
                <span className="flex h-[40px] w-[44px] items-center justify-center rounded-[12px] bg-primary-800 text-[20px] font-semibold text-white">
                  JS
                </span>
                <div className="tracking-[-0.01em]">
                  <p className="text-[14px] font-semibold leading-none text-ink">James Sterling</p>
                  <p className="mt-1 text-[12px] font-semibold leading-none text-primary-500">CFO VERIFIED</p>
                </div>
              </FloatingCard>
            </div>
          </div>
        </div>
        <div className="flex items-center gap-12 pb-4 mt-[-50px]">
          <div className="h-px flex-1 bg-line" />
          <p className="text-[14px] font-semibold tracking-[-0.01em] text-muted">
            Powering smarter business payments
          </p>
          <div className="h-px flex-1 bg-line" />
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
